var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.apiError)?_c('CardApiError',{attrs:{"error-text":_vm.$t('ADVERTISEMENT.CAMPAIGNS.API_ERROR')},on:{"retry":_vm.getCampaigns}}):_c('SearchAdsCampaignsListTable',{attrs:{"is-loading":_vm.isLoading,"campaigns":_vm.campaigns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }